angular.module('rjmNg.directives').directive "googleAdWordsProfilePicker", [
  () ->
    bindToController: true
    controllerAs: "view"
    require: "^?rjmUi"
    restrict: "E"
    scope:
      connection: "="
      options: "="
      singleSelect: "<"
      onError: '&'
    templateUrl: "directive.googleAdWordsProfilePicker.html"
    controller: [
      '$timeout'
      "InputConnections"
      "app"
      "notification"
      (
        $timeout
        InputConnections
        app
        notification
      ) ->

        view = @
        view.loading = false

        view.options ?= {}
        view.selection = {}
        view.nonManagerProfileIds = []
        view.selectedNonManagerProfileIds = []

        InputConnectionsInstance = InputConnections(app.getClientId())

        view.NOTIFICATION_SCOPE = "global"
        notification.clear(view.NOTIFICATION_SCOPE)

        ERROR_MESSAGES =
          NO_DATA: "None of the Google AdWords profiles associated with the
            credentials you've supplied contain data that Adobe Commerce Intelligence can access.
            Please make sure that the credentials you've supplied have
            appropriate access."
          PROFILES: "An error occurred fetching a list of Google AdWords
            profiles with data to track."

        showError = (message) ->
          view.loading = false
          notification.clear()
          notification.error("Something went wrong.", message, view.NOTIFICATION_SCOPE)

        # recursively extends each of the nested profiles with properties used
        # by the `treeViewDirective`. also populates the list of
        # `nonManagerProfileIds`, which are those that can be selected and
        # stored with the connection object.
        transformProfiles = (node) ->
          if node?.customerId?
            node.id = node.customerId
            node.content = node.name
            node.secondaryContent = node.customerId
            if(view.singleSelect)
              node.notSelectable = node.canManageClients isnt 'false'
            else
              node.notSelectable = false

            if node.canManageClients is 'false'
              view.nonManagerProfileIds.push node.customerId

            if node.children?
              for child in node.children
                transformProfiles(child)

            node

        preselectExistingProfileIds = ->
          profileIdsString = view.connection?.properties?.customer_ids
          return unless profileIdsString?

          profileIds = profileIdsString.split(',').map (profileId) -> +profileId

          for profileId in profileIds
            view.selection[profileId] = true

        @$onInit = () ->
          preselectExistingProfileIds()
          view.loading = true
          isArray = false
          InputConnectionsInstance.getProfiles(
            view.connection.id,
            view.connection.type,
            isArray
          ).then (allProfiles) ->
            if allProfiles?.customerId?
              view.options.profileError = false
              profiles = transformProfiles allProfiles
              view.profiles = children: [profiles]
            else
              view.options.profileError = true
              showError ERROR_MESSAGES.NO_DATA
          .catch (error) ->
            view.options.profileError = true
            showError ERROR_MESSAGES.PROFILES
          .finally () ->
            view.loading = false
            if(view.options.profileError is true && view.onError)
              $timeout(() -> 
                view.onError()
              , 0)

        view
    ]
    link: (scope, element, attributes, rjmUi) ->

      view = scope.view

      if rjmUi?
        view.setBlockedLoading = () ->
          rjmUi.loadingUi("google-ad-words-profile-picker", view.loading, "Getting Google Ads profiles")

        scope.$watch("view.loading", view.setBlockedLoading)

      scope.$watch "view.selection", (selection, oldSelection) ->
        return if _.isEqual selection, oldSelection
        view.selectedNonManagerProfileIds = []
        for profileId, profileSelected of selection
          if profileSelected and
            (profileId in view.nonManagerProfileIds) and
            (profileId not in view.selectedNonManagerProfileIds)
              view.selectedNonManagerProfileIds.push profileId
        view.options.customerIds = view.selectedNonManagerProfileIds.join(',')
      , true

]
